<template>
<div class="foot">
  <div class="content">
    <ul class="link-title">
      <li class="foot-title">服务与解决方案</li>
      <li><router-link :to="{name: 'piggery'}">猪小智模式</router-link></li>
      <li><router-link :to="{name: 'EPC'}">EPC模式</router-link></li>
      <!-- <li><router-link :to="{name: 'finance'}">金融模式</router-link></li> -->
      <li><router-link :to="{name: 'cloud'}">农信云</router-link></li>
      <li><router-link :to="{name: 'productCenter'}">产品中心</router-link></li>
      <li><router-link :to="{name: 'softwareCenter'}">软件中心</router-link></li>
    </ul>
    <ul class="link-title">
      <li class="foot-title">核心竞争力</li>
      <li><router-link :to="{name: 'coreCompetence'}">核心竞争力</router-link></li>
    </ul>
    <ul class="link-title">
      <li class="foot-title">商务合作</li>
      <li><router-link :to="{name: 'coreCompetence', query:{location:'base'}}">业务咨询</router-link></li>
      <li><router-link :to="{name: 'caseExample'}">商业案例</router-link></li>
    </ul>
    <ul class="link-title">
      <li class="foot-title">关于农芯</li>
      <li><router-link :to="{name: 'companyIntro'}">公司介绍</router-link></li>
      <li><router-link :to="{name: 'campanyNews'}">资讯中心</router-link></li>
      <li><router-link :to="{name: 'joinUs'}">加入我们</router-link></li>
      <li v-for="(item, index) in connInfoList" :key="index" @click="toUrl(item)">{{item.connName}}</li>
    </ul>
    <div class="box1">
      <img :src="basicInfo.pictureUrl" alt="">
      <h5 class="gzh">农芯微信公众号</h5>
      <h5 class="concet title">电话：{{basicInfo.phone}}</h5>
      <h5 class="concet title">商务合作：{{basicInfo.cooperationPhone}}</h5>
    </div>
  </div>
  <div class="bottom-line">
    <div class="word-bottom">
      <p>农芯数科 <a href="https://beian.miit.gov.cn/" target="_blank">闽ICP备20000314号</a></p>
      <p>京公网安备11010802031657</p>
    </div>
  </div>
</div>
</template>

<script>
import { getSession, setSession } from '@/utils/index'
export default {
  data () {
    return {
      basicInfo: {},
      connInfoList: []
    }
  },
  mounted () {
    this.getParameter()
    // if (!getSession('basicInfo')) {
    // } else {
    //   this.basicInfo = getSession('basicInfo')
    //   this.connInfoList = this.basicInfo.connInfoList
    //   this.connInfoList.filter((item) => {
    //     if (item.connName === '公司介绍' || item.connName === '资讯中心' || item.connName === '加入我们') {
    //       this.connInfoList.splice(item, 3)
    //     }
    //   })
    // }
  },
  methods: {
    toUrl (item) {
      window.open(item.connUrl)
    },
    /**
     * 获取参数设置（hr信息 / 联系方式 / 公众号）
     */
    async getParameter () {
      const res = await this.API.basic.getParameter() || []
      setSession('basicInfo', res.data)
      this.basicInfo = res.data
      this.connInfoList = this.basicInfo.connInfoList || []
      this.connInfoList.filter((item) => {
        if (item.connName === '公司介绍' || item.connName === '资讯中心' || item.connName === '加入我们') {
          this.connInfoList.splice(item, 3)
        }
      })
    }
  }
}
</script>
